/**
 * tinymce-i18n community packs sometimes leave critical strings empty (`""`),
 * so TinyMCE falls back to English. Merge fixes after the pack loads.
 */
export const TINYMCE_I18N_PATCHES: Record<string, Record<string, string>> = {
  nl: {
    Link: "Koppeling",
    "Link...": "Koppeling...",
    Url: "URL",
    "Browse links": "Links doorzoeken",
    Ok: "OK",
    Pre: "Pre",
  },
};
